import Vue from 'vue'
import Router from 'vue-router'
import BrowseHotels from '@/components/BrowseHotels'
import HotelThumbnails from '@/components/HotelThumbnails'
import HotelSearch from '@/components/HotelSearch'
import HotelFindByIDs from '@/components/HotelFindByIDs'
import HotelDetailsJSON from '@/components/HotelDetailsJSON'
import Offers from '@/components/Offers'
import OfferDetails from '@/components/OfferDetails'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hotels DB',
      component: BrowseHotels
    },
    {
      path: '/search',
      name: 'Search',
      component: HotelSearch
    },
    {
      path: '/find_by_ids',
      name: 'Hotel By IDs',
      component: HotelFindByIDs
    },
    {
      path: '/hotel/:name/thumbnails',
      name: 'Thumbnails',
      component: HotelThumbnails,
    },
    {
      path: '/hotel/json/:name/',
      name: 'Hotel Details JSON',
      component: HotelDetailsJSON,
    },
    {
      path: '/hotel/:id/offers',
      name: 'Offers',
      component: Offers,
    },
    {
      path: '/offer/:id',
      name: 'Offer Details',
      component: OfferDetails,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js